import React, { useEffect, useState } from "react";
import { useT } from "@/i18n/useT";

const KEY = "balticroots_cookie_consent";

export default function CookieBanner() {
  const t = useT();
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem(KEY)) { const timer = setTimeout(() => setShow(true), 1200); return () => clearTimeout(timer); }
  }, []);
  const accept = () => { localStorage.setItem(KEY, "accepted"); setShow(false); };
  if (!show) return null;
  return (
    <div data-testid="cookie-banner" className="fixed bottom-4 left-4 right-4 sm:left-auto sm:max-w-md z-40 bg-espresso text-cream p-6 shadow-lg">
      <p className="text-sm font-light leading-relaxed text-cream/90">{t.cookie.text}</p>
      <div className="mt-4 flex gap-4 items-center">
        <button data-testid="cookie-accept" onClick={accept} className="text-[11px] uppercase tracking-[0.3em] text-amber hover:text-cream transition-colors">{t.cookie.accept}</button>
        <a href="/privacy" className="text-[11px] uppercase tracking-[0.3em] text-cream/50 hover:text-amber transition-colors">{t.cookie.privacy}</a>
      </div>
    </div>
  );
}